module.exports = __webpack_public_path__ + "static/media/basket_icon.2805abdd.svg";